export default "__VITE_ASSET__BIHV_A5R__"